import { useContext } from 'react'

// context
import { AppContext } from '../../../../App'

// components
import DataTable from '../../../data-table/data-table'

const InjuryInsight = (): JSX.Element => {
	const appContext = useContext(AppContext)
	const report = appContext?.biomechanicalReport

	return (
		<DataTable
			headers={[
				{
					key: 'head',
					label: 'Injury Insight',
					width: '50%',
				},
				{ key: 'data', label: '', width: '50%' },
			]}
			rows={[
				{
					head: { content: 'Delta V' },
					data: {
						content: `${report?.deltav?.min || 0} - ${
							report?.deltav?.max || 0
						} km/h`,
					},
				},
				{
					head: { content: 'Injury Severity' },
					data: {
						content: report?.injurySeverity,
					},
				},
				{
					head: { content: 'Estimated Recovery' },
					data: {
						content: report?.estimateRecovery
							? report?.estimateRecovery
									?.map(
										(num) => `${num < 10 ? '0' : ''}${num}`
									)
									.join('/')
							: 'N/A',
					},
				},
				{
					head: { content: 'Prognosis' },
					data: {
						content: report?.prognosis,
					},
				},
			]}
		/>
	)
}

export default InjuryInsight
